import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"px-12 py-10",attrs:{"light":"","outlined":""}},[_c('h2',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.$t('attempting.title', { login: _vm.login }))}}),_c('lottie',{staticClass:"my-7",attrs:{"options":_vm.lottieOptions,"height":150,"width":150}}),_c('p',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.$t('attempting.description', { server: _vm.server }))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }